import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const gradientShift = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`;

export const ReadyForYouContainer = styled.div`
    padding: 2rem 1rem;
    position: relative;
    overflow: hidden;
    z-index: 1;
    min-height: 100vh;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('/img/LogoDuoaColor.png');
        background-size: 400px;
        background-repeat: repeat;
        background-position: center;
        opacity: 0.05;
        z-index: -1;
    }
`;

export const SectionTitle = styled.h1`
    font-size: 3rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff, #4ecdc4);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: ${gradientShift} 3s ease infinite, ${fadeInUp} 0.8s ease-out;

    @media (max-width: 768px) {
        font-size: 2.2rem;
    }

    @media (max-width: 480px) {
        font-size: 1.8rem;
    }
`;

export const SectionSubtitle = styled.p`
    font-size: 1.2rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    max-width: 600px;
    margin: 0 auto 2rem;
    line-height: 1.6;
    animation: ${fadeInUp} 0.8s ease-out 0.2s both;

    @media (max-width: 768px) {
        font-size: 1.1rem;
        padding: 0 1rem;
    }

    @media (max-width: 480px) {
        font-size: 1rem;
    }
`;

export const SearchWrapper = styled.div`
    max-width: 500px;
    margin: 0 auto 2rem;
    padding: 0 1rem;
    animation: ${fadeInUp} 0.8s ease-out 0.3s both;
`;

export const ResultsCount = styled.p`
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.95rem;
    margin-bottom: 1.5rem;
`;

export const ProductsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 2rem;
    padding: 1rem 0;
    max-width: 1200px;
    margin: 0 auto;
    animation: ${fadeInUp} 0.8s ease-out 0.4s both;

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 1.5rem;
        padding: 1rem;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
        padding: 0.5rem;
    }
`;

export const NoResultsMessage = styled.div`
    text-align: center;
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.7);
    padding: 4rem 2rem;
    max-width: 600px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 20px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
`;
